import * as React from 'react';
import { Global } from '@emotion/react';

const fontUrl = 'https://common-assets.srv.connectedcare.io/cc-common-assets/fonts/Muli';

const GlobalStyle: React.FC = () => (
  <Global
    styles={() => [
      {
        '@font-face': {
          fontFamily: 'Muli',
          src: `local(Muli-Regular), url('${fontUrl}/Muli-Regular.ttf') format("truetype")`,
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontDisplay: 'swap',
        },
      },
      {
        '@font-face': {
          fontFamily: 'Muli',
          src: `local(Muli-Bold), url('${fontUrl}/Muli-Bold.ttf') format("truetype")`,
          fontWeight: 'bold',
          fontStyle: 'normal',
          fontDisplay: 'swap',
        },
      },
      {
        'html, body': {
          margin: 0,
          padding: 0,
        },
      },
    ]}
  />
);

export default GlobalStyle;
